import {injectable} from "inversify";

@injectable()
export default class UserMatchHandler {
  private resolver?: () => void;

  public async start(): Promise<void> {
    if (this.resolver) {
      await this.resolver();
    }

    return new Promise((resolve) => this.resolver = resolve);
  }

  public async continue() {
    if (!this.resolver) {
      throw 'There is not resolver stored.'
    }

    await this.resolver();
  }
}
